module.exports = ".mat-raised-button.mat-accent {\r\n  background-color: #eb008f;\r\n  color: #fff;\r\n  width: 45%;\r\n}\r\n"